import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./context/user.context";
import { ProductsProvider } from "./context/products.context";
import { CartProivder } from "./context/cart.context";
import { registerLicense } from "@syncfusion/ej2-base";

import App from "./App";

import "./App.css";
import "./index.css";
import AnnouncementModal from "./spa/AnnouncementModal";
import { AuthProvider } from "./context/auth.context";

// Registering Syncfusion license key.
registerLicense(`${process.env.REACT_APP_SYNCFUSION_LICENSE_KEY}`);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <UserProvider>
        <ProductsProvider>
          <CartProivder>
            <AnnouncementModal />
            <App />
          </CartProivder>
        </ProductsProvider>
      </UserProvider>
    </BrowserRouter>
  </AuthProvider>
);
